/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-indent */
/* eslint-disable function-paren-newline */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */

/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader, RegularButton } from 'pg-ui-library';
import Arrow from 'src/assets/arrow-left-black.svg';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Container,
  Content,
  Header,
  Tab,
  TabContainer,
  TabTitle,
  PageTitle,
  NavTextLink,
  ArrowBack,
  EmptyContainer,
} from './styles';
import { BenefitForm } from '../benefit-form';

import { BenefitPriceWrapper } from '../benefit-price-wrapper';
import { BenefitDocumentWrapper } from '../benefit-document';

import { BenefitAgeLines } from '../benefit-age-lines';
import { BenefitLimitedRange } from '../benefit-limited-range';
import { useBenefitTypeByVersionId } from '../../queries/benefit-type-by-version-id.query';

export const BenefitEditPage: React.FC = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<string>('General');

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  const { versionId } = useParams();

  const { data, isLoading, refetch, isFetching } = useBenefitTypeByVersionId({ id: versionId as string });

  const totalBenefits = data?.typeBenefit.length || 0;
  const limitedBenefitsCount = data?.typeBenefit.filter(v => v.costCalculationMethod === 'Limited').length || 0;
  const hasLimitedBenefits = limitedBenefitsCount > 0;
  const hasNonLimitedBenefits = totalBenefits > limitedBenefitsCount;
  const hasTableBenefits = data?.typeBenefit.some(v => v.costCalculationMethod === 'Table') || false;

  const tabs = useMemo(() => {
    const items: string[] = ['General'];
    if (hasNonLimitedBenefits) {
      items.push('Price');
    }
    if (hasLimitedBenefits) {
      items.push('Limited Range');
    }
    items.push('Document');
    if (hasTableBenefits) {
      items.push('Age Price Lines');
    }
    return items;
  }, [hasLimitedBenefits, hasNonLimitedBenefits, hasTableBenefits]);

  useEffect(() => {
    if (tab && tabs.includes(tab)) {
      setSelectedTab(tab);
    } else {
      setSelectedTab(tabs[0]);
    }
  }, [tab, tabs]);

  useEffect(() => {
    refetch();
  }, [versionId]);

  if (isLoading || isFetching) {
    return (
      <EmptyContainer>
        <Loader />
      </EmptyContainer>
    );
  }

  const getTabContent = () => {
    switch (selectedTab) {
      case 'General':
        return <BenefitForm selectedBenefitType={data} onClose={() => {}} />;
      case 'Price':
        return <BenefitPriceWrapper selectedBenefitType={data} />;
      case 'Document':
        return <BenefitDocumentWrapper selectedBenefitType={data} onClose={() => {}} />;
      case 'Limited Range':
        return <BenefitLimitedRange selectedBenefitType={data} />;
      case 'Age Price Lines':
        return <BenefitAgeLines selectedBenefitType={data} />;
      default:
        return <EmptyContainer>{t('global.form.empty')}</EmptyContainer>;
    }
  };

  return (
    <Container>
      <Header>
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          <NavTextLink to={`/benefits/edit/${data?.type}`}>
            <ArrowBack src={Arrow} />
          </NavTextLink>
          <PageTitle>{t('benefits.editModal.title')}</PageTitle>
        </div>
        {hasTableBenefits && (
          <NavTextLink to={`/benefits/premium/${data?.type}/${versionId}`}>
            <RegularButton>{t('benefits.edit.premiumAndPayoutConfig')}</RegularButton>
          </NavTextLink>
        )}
      </Header>
      {isLoading ? (
        <EmptyContainer>
          <Loader />
        </EmptyContainer>
      ) : (
        <Container>
          <TabContainer>
            {tabs.map(currTab => (
              <Tab
                key={currTab}
                selected={currTab === selectedTab}
                onClick={() => {
                  setSelectedTab(currTab);
                  navigate(`?tab=${currTab}`);
                }}
              >
                <TabTitle>{currTab}</TabTitle>
              </Tab>
            ))}
          </TabContainer>
          <Content>{getTabContent()}</Content>
        </Container>
      )}
    </Container>
  );
};
